import React, { useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  errorMessage,
  formatUsername,
} from "../../../util/Helpers";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { useDownloadUsersByTradeActivityReportMutation } from "../../../../redux/apiSlice";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { Permission } from "../../Common/layout/Permission";

export const LastTradedReportTable = () => {
  const tableRef = useRef();

  const [
    downloadTradeActivityReport,
    {
      isLoading: isLoadingReport,
      isSuccess: isReportGenerating,
      error: errorReport,
    },
  ] = useDownloadUsersByTradeActivityReportMutation();

  useEffect(() => {
    if (errorReport) {
      cogoToast.error(errorReport.data);
    }
  }, [errorReport]);

  useEffect(() => {
    if (isReportGenerating) {
      cogoToast.success(
        `Report export in progress. The resulting file will be sent to your mail.`
      );
    }
  }, [isReportGenerating]);

  return (
    <div className="py-4 px-6">
      <FilterGroup>
        <FilterGroup.Date
          name={"lastTradedBefore"}
          label={"Last Traded Before"}
          className={"mb-4"}
        />
        <FilterGroup.Content>
          {({ filters }) => {
            return (
              <Card>
                <CardHeader
                  title={`Users that last traded before ${filters?.lastTradedBefore ||
                    "today"}`}
                >
                  <Permission
                    permission={Permissions.REPORTS}
                    permissionType={PermissionType.CREATE}
                  >
                    <CardHeaderToolbar>
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={isLoadingReport}
                        onClick={() =>
                          downloadTradeActivityReport({
                            side: "buyAndSell",
                            comparator: "eq",
                            amount: 0,
                            startDate: filters?.lastTradedBefore || "",
                            endDate: "",
                          })
                        }
                      >
                        Export CSV
                      </button>
                    </CardHeaderToolbar>
                  </Permission>
                </CardHeader>
                <CardBody>
                  <DynamicSimpleTable
                    queryParams={
                      `side=buyAndSell` +
                      `&comparator=eq` +
                      `&amount=0` +
                      `&startDate=${filters?.lastTradedBefore || ""}`
                    }
                    searchBox={false}
                    source={{ url: `/reports/users-by-trade-frequency` }}
                    columns={[
                      {
                        title: "USER",
                        format: (row) =>
                          formatUsername(
                            row.userId,
                            row.username,
                            null,
                            null,
                            null
                          ),
                      },
                      { title: "EMAIL", key: "email" },
                      { title: "PHONE", key: "phone" },
                      { title: "USER GROUP", key: "userGroup" },
                    ]}
                    onError={(err) => cogoToast.error(errorMessage(err))}
                    refreshIcon={true}
                    ref={tableRef}
                  />
                </CardBody>
              </Card>
            );
          }}
        </FilterGroup.Content>
      </FilterGroup>
    </div>
  );
};
